// Polyfills for Node.js globals in browser
import { Buffer } from 'buffer';
import process from 'process/browser.js';

// Make Buffer and process available globally
window.Buffer = window.Buffer || Buffer;
window.process = window.process || process;
window.global = window.global || window;

// Set NODE_ENV if not already set
if (!process.env.NODE_ENV) {
  process.env.NODE_ENV = 'production';
}

export { Buffer, process };
